<template>
  <!-- v-if="hasPlaybackSpeed" -->
  <div

    class="speed-control"
    :class="popupVisible ? 'active' : ''"
    @mouseleave="popupVisible = false"
  >
    <VsButton
      class="p-0"
      :tracker="getAnalyticPayload(e => e.player['control-bar'].click.speed)"
      icon="md:slow_motion_video"
      @click.native="popupVisible = !popupVisible"
    />

    <div
      v-if="popupVisible"
      class="speed-control__window"
    >
      <div
        v-for="(playback) in processedPlaybackSpeed"
        :key="playback.label"
        v-analytic="{
          action: 'click-button',
          label: 'speed',
          value: `${playback.speed}`
        }"
        class="speed-control__window__item"
        :class="currentSpeed === playback.speed ? 'active' : ''"
        @click="$_changeSpeed({playback})"
      >
        {{ playback.label }}
      </div>
    </div>
  </div>
</template>

<script>
import VsButton from '@/scripts/Components/Molecules/VsButton';
import { getAnalyticPayload } from '@/scripts/libs/analytic';
import { analyticUiEventDirective } from '@/scripts/libs/analytic/support/vue/directives';
import { SPEED_OPTIONS } from './PlayerControlConstants';

export default {
  directives: {
    analytic: analyticUiEventDirective,
  },
  SPEED_OPTIONS,
  components: {
    VsButton,
  },
  props: {
    playbackSpeed: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      popupVisible: false,
      currentSpeed: 1,
    };
  },

  computed: {
    hasPlaybackSpeed() {
      return this.playbackSpeed && (this.playbackSpeed.length > 0);
    },

    processedPlaybackSpeed() {
      if (!this.playbackSpeed) return [];
      return SPEED_OPTIONS.map((speed) => {
        const label= `${speed}x`;
        return ({
          speed,
          label,
        });
      });
    },
  },

  methods: {
    $_changeSpeed({ playback }) {
      this.analytic.send(
        getAnalyticPayload(
          e => e.player['change-speed'],
          playback.label,
        ),
      );
      this.currentSpeed=playback.speed;
      this.$emit('speedChanged', playback.speed);
    },

    getAnalyticPayload,
  },
};
</script>

<style lang="scss" scoped>
$active-bg-color: rgba(black, 0.95);

.speed-control {
  position: relative;
  z-index: 1;
  .vs-icon {
    transform: rotate(0deg);
    transition: transform 0.25s;
  }
}
.speed-control.active {
  background-color: $active-bg-color;

  .vs-icon {
    color: white;
    transform: rotate(90deg);
  }
  .speed-control__window {
    background-color: $active-bg-color;
  }
}

.speed-control__window {
  position: absolute;
  bottom: 100%;
  right: 0;
  padding: 8px 0;
  width: auto;
  height: auto;
  max-height: calc(56vw - 20px); // prevent small screen from not able to select speed
  overflow: auto;
}

.speed-control__window__item {
  padding: 8px 36px;
  cursor: pointer;
}
.speed-control__window__item:hover {
  background: rgba(white, 0.1);
}
.speed-control__window__item.active {
  background: rgba(white, 0.2);
}
</style>
